import api from "../../index";

export const GetTagListApi = (data) => api.post('taglist', data);
export const AddUpdateTagApi = (data) => api.post('addupdatetags', data);
export const UpdateTagStatusApi = (data) => api.post('changestatusoftags', data);
export const DeleteTagApi = (data) => api.post('deletetags', data);